exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".item-top {\n  height: 80%; }\n\n.item-bottom {\n  height: 20%; }\n\n.deposit-wrapper-container {\n  height: 100%; }\n\n.buttons-card {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  -ms-flex-align: end;\n      align-items: end; }\n\n.upper-table {\n  border-collapse: collapse;\n  width: 20%;\n  border: none; }\n\n.low-table {\n  margin-left: 20%;\n  border-collapse: collapse;\n  width: 20%;\n  border: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing-general/deposits/electronic-details/electronic-details.component.scss
// module id = 1967
// module chunks = 66